<template>
	<div data-tour-scope="items-list">
		<v-main>
			<v-container fluid fill-height>
				<v-layout justify-center align-center v-resize="onResize">
					<v-card width="100%" outlined elevation-0>
						<v-toolbar flat class="border_bottom" shaped>
							<v-toolbar-title>
								{{ this.$vuetify.lang.t('$vuetify.front.items.items') }}
								<v-chip color="primary" variant="flat" class="ml-3" data-tour="warehouse">
									Valore magazzino <b class="ml-3">€{{ totalwarehouse ? totalwarehouse.toFixed(2) : 0 }}</b>
								</v-chip>
							</v-toolbar-title>
							<v-btn class="ml-6" outlined color="primary" data-tour="tutorial" @click="tour.start()">
								<v-icon left>mdi-school-outline</v-icon>
								Tutorial guidato
							</v-btn>

							<v-spacer></v-spacer>
							<v-toolbar-items shift>
								<v-btn text to="/trash/items"><v-icon left>mdi-delete-restore</v-icon>Cestino</v-btn>
								<!--<v-btn text :href="linkdownload+'?search='+searchfield+'&categories='+settings.filters.categories+'&selected='+selected" exact >
                                    <v-icon>mdi-arrow-collapse-down</v-icon>
                                </v-btn>-->

								<v-menu bottom :close-on-click="closeOnClick" elevation-0>
									<template v-slot:activator="{ on, attrs }">
										<v-btn elevation="0" v-bind="attrs" v-on="on" text data-tour="export">
											<v-icon>mdi-arrow-collapse-down</v-icon>
										</v-btn>
									</template>

									<v-list elevation="0">
										<v-list-item data-tour="export-csv" @click="exportItems('csv')">
											<v-list-item-icon>
												<v-icon>mdi-arrow-collapse-down</v-icon>
											</v-list-item-icon>

											<v-list-item-content>
												<v-list-item-title>Esporta in CSV</v-list-item-title>
											</v-list-item-content>
										</v-list-item>

										<v-list-item @click="exportItems('excel')">
											<v-list-item-icon>
												<v-icon>mdi-arrow-collapse-down</v-icon>
											</v-list-item-icon>
											<v-list-item-content>
												<v-list-item-title>Esporta in Excel</v-list-item-title>
											</v-list-item-content>
										</v-list-item>
										<v-list-item @click="exportItems('excelSingolo')">
											<v-list-item-icon>
												<v-icon>mdi-arrow-collapse-down</v-icon>
											</v-list-item-icon>
											<v-list-item-content>
												<v-list-item-title>Esporta unica variante in Excel</v-list-item-title>
											</v-list-item-content>
										</v-list-item>
									</v-list>
								</v-menu>

								<!--<v-btn text @click="toggleDrawerSort">
                                  <v-icon>mdi-sort</v-icon>
                              </v-btn>-->
								<!-- <v-divider vertical></v-divider>-->
								<!--								<v-btn text @click="toggleDrawerFilter">
									<v-icon>mdi-magnify</v-icon>
								</v-btn>-->

								<!-- <v-divider vertical></v-divider>-->
								<v-menu bottom :close-on-click="closeOnClick" elevation-0>
									<template v-slot:activator="{ on, attrs }">
										<v-btn elevation="0" v-bind="attrs" v-on="on" text data-tour="add">
											<v-icon>mdi-plus</v-icon>
										</v-btn>
									</template>

									<v-list elevation="0">
										<!--<v-list-item @click="getCategoryMagento" v-if="magento">
                                            <v-list-item-icon>
                                                <v-icon>mdi-plus</v-icon>
                                            </v-list-item-icon>

                                            <v-list-item-content>
                                                <v-list-item-title>Importa da Magento</v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>-->
										<v-list-item data-tour="add-item" @click="createItem">
											<v-list-item-icon>
												<v-icon>mdi-plus</v-icon>
											</v-list-item-icon>

											<v-list-item-content>
												<v-list-item-title>Aggiungi prodotto</v-list-item-title>
											</v-list-item-content>
										</v-list-item>
										<!--@click="getItemsShopifyAz"-->

										<v-list-item @click="importItemFromShopify" v-if="shopify">
											<v-list-item-icon>
												<v-icon>mdi-plus</v-icon>
											</v-list-item-icon>

											<v-list-item-content>
												<v-list-item-title>Aggiungi prodotto singolo da shopify</v-list-item-title>
											</v-list-item-content>
										</v-list-item>
										<!--										<v-list-item @click="importNewItemShopify" v-if="shopify">
											<v-list-item-icon>
												<v-icon>mdi-plus</v-icon>
											</v-list-item-icon>

											<v-list-item-content>
												<v-list-item-title>Importa nuovi prodotti Shopify</v-list-item-title>
											</v-list-item-content>
										</v-list-item>-->
										<v-list-item @click="importItemConfirmShopify" v-if="shopify">
											<v-list-item-icon>
												<v-icon>mdi-plus</v-icon>
											</v-list-item-icon>

											<v-list-item-content>
												<v-list-item-title>Importa da Shopify</v-list-item-title>
											</v-list-item-content>
										</v-list-item>

										<v-list-item data-tour="add-file" @click="getFileCategories">
											<v-list-item-icon>
												<v-icon>mdi-plus</v-icon>
											</v-list-item-icon>

											<v-list-item-content>
												<v-list-item-title>Importa da file esterno</v-list-item-title>
											</v-list-item-content>
										</v-list-item>
									</v-list>
								</v-menu>
								<!--<v-divider vertical></v-divider>
-->
							</v-toolbar-items>
						</v-toolbar>


						<v-col cols="12">
							<v-row data-tour="filters">
								<v-col cols="12" md="4" data-tour="search">
									<v-text-field v-model="searchfield" label="Cerca" outlined append-icon="mdi-magnify" dense @click:append="getSearch()" @keyup.enter="getSearch()" hide-details></v-text-field>
								</v-col>
								<v-col cols="12" md="4">
									<v-autocomplete
										v-model="settings.filters.brand"
										:menu-props="{ closeOnContentClick: true }"
										:items="brands"
										outlined
										label="Brand"
										item-value="_id"
										multiple
										item-text="trans.name"
										clearable
										dense
										hide-details
									></v-autocomplete>
								</v-col>
								<v-col cols="12" md="4">
									<v-autocomplete
										outlined
										v-model="settings.filters.categories"
										:menu-props="{ closeOnContentClick: true }"
										multiple
										:items="listcategories"
										label="Categorie"
										item-value="_id"
										item-text="string"
										clearable
										dense
										hide-details
									>
									</v-autocomplete>
								</v-col>
								<v-col cols="12" md="4">
									<v-autocomplete hide-details="auto"
										outlined
										v-model="settings.filters.suppliers"
										:menu-props="{ closeOnContentClick: true }"
										:items="suppliers"
										label="Fornitore"
										item-value="_id"
										multiple
										item-text="Company"
										clearable
										dense
										:search-input.sync="search"
									></v-autocomplete>
								</v-col>
								<v-col cols="12" md="4">
									<v-select
										v-model="settings.filters.color"
										outlined
										:menu-props="{ closeOnContentClick: true }"
										:items="selectColor"
										label="Tags"
										multiple
										clearable
										prepend-inner-icon="mdi-tag"
										dense
										hide-details
									></v-select>
								</v-col>
								<v-col cols="12" md="4">
									<v-select
										v-model="settings.filters.images"
										outlined
										:menu-props="{ closeOnContentClick: true }"
										:items="options"
										label="Immagini presenti"
										item-value="value"
										item-text="text"
										clearable
										dense
										hide-details
									></v-select>
								</v-col>
							</v-row>
						</v-col>

						<v-data-table
							data-tour="table"
							:headers="headers"
							:items="getItems"
							:options.sync="settings.options"
							:server-items-length="total"
							must-sort
							class="elevation-0"
							:mobile-breakpoint="0"
							:footer-props="{ 'items-per-page-options': listSize }"
							item-key="item._id"
							:hide-default-header="mobileCards"
							:class="{ 'table-cards': mobileCards, 'tabella-compatta': !mobileCards }"
						>
							<template v-slot:body="{ items }">
								<!-- telefono: ogni prodotto diventa una card chiave/valore -->
								<tbody v-if="mobileCards" class="item-cards">
									<tr v-for="item in items" :key="item._id + '-' + (item.variants && item.variants._id)">
										<td :colspan="headers.length" class="px-3 py-1">
											<key-value-card :fields="campiCard(item)" :image="getImage(item) || imagePlaceholder" :image-fallback="imagePlaceholder">
												<template v-slot:title>
													<span v-html="convertSearch((item.trans && item.trans.name) || 'Prodotto')"></span>
													<!-- come negli ordini: la lente apre la scheda, il nome resta testo -->
													<v-btn icon x-small class="ml-1" title="Apri prodotto" @click="editItem(item)">
														<v-icon small>mdi-magnify</v-icon>
													</v-btn>
												</template>
												<template v-slot:actions>
													<v-menu offset-y>
														<template v-slot:activator="{ on }">
															<v-btn icon small elevation="0" :color="item.Color || 'grey'" v-on="on" title="Etichetta colore">
																<v-icon small>mdi-tag</v-icon>
															</v-btn>
														</template>
														<v-list dense>
															<v-list-item v-for="colore in coloriEtichetta" :key="colore">
																<v-btn @click="changeFlag(item, colore)" elevation="0" icon :color="colore"><v-icon>mdi-tag</v-icon></v-btn>
															</v-list-item>
														</v-list>
													</v-menu>
													<v-menu :transition="false" offset-y eager>
														<template v-slot:activator="{ on, attrs }">
															<v-btn icon small color="primary" v-bind="attrs" v-on="on" data-tour="row-menu">
																<v-icon>mdi-dots-vertical</v-icon>
															</v-btn>
														</template>
														<v-list>
															<v-list-item v-for="menu of menuInline" :key="menu.operation" :data-tour="`row-${menu.operation}`" @click="navigateTo(menu.operation, item)">
																<v-list-item-title class="size9">{{ menu.text }}</v-list-item-title>
															</v-list-item>
															<v-list-item v-if="shopify" data-tour="row-shopify" @click="updateFromShopify(item)">
																<v-list-item-title class="size9">Aggiorna da Shopify</v-list-item-title>
															</v-list-item>
														</v-list>
													</v-menu>
												</template>
												<template v-slot:top>
													<div v-if="(item.brand && item.brand.trans && item.brand.trans.name) || marketplaceAttivi(item).length" class="d-flex align-center flex-wrap mb-2">
														<span v-if="item.brand && item.brand.trans && item.brand.trans.name" class="mr-2 item-brand">{{ item.brand.trans.name }}</span>
														<a v-for="(market, mi) of marketplaceAttivi(item)" :key="mi" :href="market.url" target="_blank" class="d-inline-flex align-center mr-2">
															<img :src="getImageMarketplace(market.platform)" :alt="market.platform" style="height: 18px" />
															<img :src="getImageFlag(market.country)" :alt="market.country" style="height: 14px; margin-left: 2px" />
														</a>
													</div>
												</template>
												<div class="d-flex align-center justify-space-between" data-tour="status">
													<span class="item-label">Prodotto attivo</span>
													<v-switch v-model="item.is_active" @change="changeStatus(item)" color="primary" class="mt-0 pt-0" hide-details></v-switch>
												</div>
												<div v-if="item.variante" class="d-flex align-center justify-space-between mt-1">
													<span class="item-label">Variante attiva</span>
													<v-switch v-model="item.variants.active" @change="changeStatusVariant(item)" color="primary" class="mt-0 pt-0" hide-details></v-switch>
												</div>
												<div v-if="(item.categories || []).some(el => el && el.trans && el.trans.name)" class="mt-2">
													<template v-for="(el, ci) of item.categories">
														<v-chip v-if="el && el.trans && el.trans.name" :key="ci" x-small class="mr-1 mb-1">{{ el.trans.name }}</v-chip>
													</template>
												</div>
												<div v-if="(item.lingue || []).length" class="d-flex align-center justify-space-between mt-2">
													<span class="item-label">Lingue</span>
													<LingueFlags :lingue="item.lingue" />
												</div>
											</key-value-card>
										</td>
									</tr>
								</tbody>
								<tbody v-else>
									<template v-for="(item, index) in items">
										<tr>
											<td class="pl-0 pr-0 ml-0 mr-0" style="width: 5px">
												<v-menu :transition="false" offset-y eager>
													<template v-slot:activator="{ on, attrs }">
														<v-btn icon dark v-bind="attrs" v-on="on" color="primary" dense data-tour="row-menu">
															<v-icon dark> mdi-dots-vertical </v-icon>
														</v-btn>
													</template>
													<v-list>
														<v-list-item v-for="menu of menuInline" :key="menu.operation" :data-tour="`row-${menu.operation}`" @click="navigateTo(menu.operation, item)">
															<v-list-item-title class="size9">{{ menu.text }}</v-list-item-title>
														</v-list-item>

														<v-list-item v-if="shopify" data-tour="row-shopify" @click="updateFromShopify(item)">
															<v-list-item-title class="size9">Aggiorna da Shopify</v-list-item-title>
														</v-list-item>
													</v-list>
												</v-menu>
											</td>
											<td data-tour="status">
												Item<br />
												<v-switch v-model="item.is_active" @change="changeStatus(item)" color="primary" class="mt-0" hide-details></v-switch>
												<span v-if="item.variante">
													<p class="mt-4">
														Variant<br />
														<v-switch v-model="item.variants.active" @change="changeStatusVariant(item)" color="primary" class="mt-0" hide-details></v-switch>
													</p>
												</span>
											</td>

											<td>
												{{ item.created_at | moment('DD/MM/YYYY') }}
											</td>
											<td>
												{{ item.updated_at | moment('DD/MM/YYYY') }}
											</td>
											<td>
												<!--											<v-img class="mt-1 mb-1" max-height="100" max-width="100" :ref="index" :src="createImage(item)" @error="imageUrlAlt(index)"></v-img>-->
												<!--											<v-img class="mt-1 mb-1" max-height="100" max-width="100" :ref="index" :src="createImage(item)" @error="imageUrlAlt(item)"></v-img>-->
												<template v-if="getImage(item)">
													<v-img class="mt-1 mb-1" max-height="100" max-width="100" :ref="index" :src="getImage(item)"></v-img>
												</template>
												<template v-else>
													<v-img class="mt-1 mb-1" max-height="100" max-width="100" :ref="index" src="@/assets/images/picture.svg"></v-img>
												</template>
												<!---->
											</td>
											<td class="product-cell">
												<div v-if="item.trans && item.trans.name" class="product-name">
													<span v-html="convertSearch(item.trans.name)"></span>
													<!-- come negli ordini: la lente apre la scheda, il nome resta testo -->
													<v-btn icon x-small class="ml-1" title="Apri prodotto" @click="editItem(item)">
														<v-icon small>mdi-magnify</v-icon>
													</v-btn>
												</div>
												<div v-if="item.brand && item.brand.trans && item.brand.trans.name">{{ item.brand.trans.name }}</div>
												<div v-if="item.model"><span class="product-label">Mod.</span> <span v-html="convertSearch(item.model)"></span></div>
												<div v-if="item.variants && item.variants.sku"><span class="product-label">SKU</span> <span v-html="convertSearch(item.variants.sku)"></span></div>
												<div v-if="item.variants && item.variants.ean"><span class="product-label">EAN</span> <span v-html="convertSearch(item.variants.ean)"></span></div>
												<div v-if="supplierNames(item)">{{ supplierNames(item) }}</div>
												<div v-if="(item.categories || []).some(el => el && el.trans && el.trans.name)" class="product-categories">
													<template v-for="el of item.categories">
														<v-chip v-if="el && el.trans && el.trans.name" x-small class="mr-1 mt-1">
															{{ el.trans.name }}
														</v-chip>
													</template>
												</div>
											</td>
											<td class="stack-cell">
												<template v-if="item.variante">
													<div v-for="element in item.variants.variants">
														<b>{{ element?.name?.trans }}</b>
														{{ element?.value?.trans }}
													</div>
												</template>
												<div>
													<span class="product-label">Qtà</span> {{ item.variants.qt }}
													<span v-if="item.variants.unit && item.variants.unit.trans">{{ item.variants.unit.trans }}</span>
												</div>
											</td>

											<td class="stack-cell text-no-wrap">
												<div v-if="formatPrice(item.variants.sell)" title="Prezzo di vendita senza IVA">
													<span class="product-label">Vendita</span> <b>{{ formatPrice(item.variants.sell) }} {{ item.variants.currency }}</b>
												</div>
												<div v-if="formatPrice(item.variants.pricevat)" title="Prezzo di vendita IVA inclusa">
													<span class="product-label">Con IVA</span> {{ formatPrice(item.variants.pricevat) }} {{ item.variants.currency }}
													<span v-if="item.vat" class="product-label ml-1">({{ item.vat }}%)</span>
												</div>
												<div v-if="formatPrice(item.variants.buy) || item.variants.qtunit" class="price-purchase">
													<div v-if="formatPrice(item.variants.buy)" title="Costo d'acquisto di una singola unità dal fornitore">
														<span class="product-label">Acquisto</span> {{ formatPrice(item.variants.buy) }} {{ item.variants.currency }} cad.
													</div>
													<div v-if="item.variants.qtunit" title="Quante unità d'acquisto compongono un'unità venduta: il prezzo di vendita si calcola su acquisto × questa quantità">
														<span class="product-label">Unità per vendita</span> {{ item.variants.qtunit }}
													</div>
												</div>
												<div v-if="item.weight"><span class="product-label">Peso</span> {{ item.weight }} gr.</div>
											</td>
											<td>
												<v-chip v-if="item.marketplace.length > 0 && market.status === 'Confirmed'" v-for="(market, index) of item.marketplace" :key="index" class="ma-1">
													<a :href="market.url" target="_blank">
														<v-avatar left>
															<img :src="getImageMarketplace(market.platform)" :alt="market.platform" />
														</v-avatar>
														<v-avatar>
															<img :src="getImageFlag(market.country)" :alt="market.country" />
														</v-avatar>
													</a>
												</v-chip>
											</td>
											<td data-tour="langs"><LingueFlags :lingue="item.lingue" /></td>
											<td>
												<v-menu
													:disabled="disabled"
													:absolute="absolute"
													:open-on-hover="openOnHover"
													:close-on-click="closeOnClick"
													:close-on-content-click="closeOnContentClick"
													:offset-x="offsetX"
													:offset-y="offsetY"
												>
													<template v-slot:activator="{ on }">
														<v-btn icon small elevation="0" :color="item.Color || 'grey'" v-on="on">
															<v-icon>mdi-tag</v-icon>
														</v-btn>
													</template>
													<v-list dense>
														<v-list-item>
															<v-btn @click="changeFlag(item, 'red')" elevation="0" icon color="red"><v-icon>mdi-tag</v-icon></v-btn>
														</v-list-item>
														<v-list-item>
															<v-btn @click="changeFlag(item, 'pink')" elevation="0" icon color="pink"><v-icon>mdi-tag</v-icon></v-btn>
														</v-list-item>
														<v-list-item>
															<v-btn @click="changeFlag(item, 'purple')" elevation="0" icon color="purple"><v-icon>mdi-tag</v-icon></v-btn>
														</v-list-item>
														<v-list-item>
															<v-btn @click="changeFlag(item, 'indigo')" elevation="0" icon color="indigo"><v-icon>mdi-tag</v-icon></v-btn>
														</v-list-item>
														<v-list-item>
															<v-btn @click="changeFlag(item, 'blue')" elevation="0" icon color="blue"><v-icon>mdi-tag</v-icon></v-btn>
														</v-list-item>
														<v-list-item>
															<v-btn @click="changeFlag(item, 'green')" elevation="0" icon color="green"><v-icon>mdi-tag</v-icon></v-btn>
														</v-list-item>
														<v-list-item>
															<v-btn @click="changeFlag(item, 'yellow')" elevation="0" icon color="yellow"><v-icon>mdi-tag</v-icon></v-btn>
														</v-list-item>
														<v-list-item>
															<v-btn @click="changeFlag(item, 'orange')" elevation="0" icon color="orange"><v-icon>mdi-tag</v-icon></v-btn>
														</v-list-item>
														<v-list-item>
															<v-btn @click="changeFlag(item, 'grey')" elevation="0" icon color="grey"><v-icon>mdi-tag</v-icon></v-btn>
														</v-list-item>
													</v-list>
												</v-menu>
											</td>
											<!--td>{{ item.id }}</td-->
										</tr>
									</template>
								</tbody>
							</template>
						</v-data-table>
					</v-card>
					<v-snackbar v-model="snackbar.snackbar" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :vertical="snackbar.mode === 'vertical'">
						{{ snackbar.text }}
						<v-btn dark text @click="snackbar = false"> Close </v-btn>
					</v-snackbar>
				</v-layout>
			</v-container>
		</v-main>
		<v-dialog :value="getDialog" fullscreen hide-overlay eager transition="dialog-bottom-transition" persistent internal-activator no-click-animation :eager="true" :retain-focus="false">
			<!-- crea, modifica e duplica sono pagine (/items/new, /items/:id, /items/:id/duplicate) -->
			<FormMap v-if="operation === 'FormMap'" :key="componentKey" @event="getDataFromApi" @message="propSetMessages"></FormMap>
			<ImportShopify v-if="operation === 'ImportShopify'" :key="componentKey" @event="getDataFromApi" @message="propSetMessages"></ImportShopify>
			<FormFile v-if="operation === 'FormFile'" :key="componentKey" @event="getDataFromApi" @message="propSetMessages"></FormFile>
		</v-dialog>

		<v-dialog v-model="dialogconfirm" max-width="290">
			<v-card>
				<v-card-title class="headline">Sei sicuro?</v-card-title>
				<v-card-text>Il prodotto sarà spostato nel cestino. Dati, varianti e collegamenti saranno conservati per il ripristino. Le offerte sui marketplace richiedono una gestione separata.</v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>

					<v-btn color="primary" text @click="dialogconfirm = false"> Annulla </v-btn>

					<v-btn color="primary" text @click="confirmDelete"> Conferma </v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog v-model="dialogconfirmUpdate" max-width="290">
			<v-card>
				<v-card-title class="headline">Sei sicuro?</v-card-title>
				<v-card-text>Importando il prodotto da shopify alcune informazioni potrebbero essere sovrascritte </v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>

					<v-btn color="primary" text @click="dialogconfirmUpdate = false"> Annulla </v-btn>

					<v-btn color="primary" text @click="updateFromShopify"> Conferma </v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog v-model="dialogconfirmImport" max-width="290">
			<v-card>
				<v-card-title class="headline">Sei sicuro?</v-card-title>
				<v-card-text>Verranno inseririti tutti i prodotti presenti su shopify che ancora non sono inseriri su AzSeller </v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>

					<v-btn color="primary" text @click="dialogconfirmImport = false"> Annulla </v-btn>

					<v-btn color="primary" text @click="getItemsShopifyAz"> Conferma </v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<!-- Ultimo elemento: il nodo viene spostato in `[data-app]` al montaggio. -->
		<TourOverlay :tour="tour"></TourOverlay>
	</div>
</template>

<script>
import Vue from 'vue';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import VuetifyDraggableTreeview from 'vuetify-draggable-treeview';
import axios from 'axios';
import { Category } from '../../utils/Category';
Vue.use(VuetifyDraggableTreeview);

const FormMap = () => import('@/components/items/Map.vue');
const FormFile = () => import('@/components/items/File.vue');
const ImportShopify = () => import('@/components/items/ImportShopify.vue');

import TourOverlay from '@/components/core/tour/TourOverlay.vue';
import KeyValueCard from '@/components/core/KeyValueCard.vue';
import LingueFlags from '@/components/core/LingueFlags.vue';
import { useTour } from '@/components/core/tour/useTour';
import { listRouteState } from '@/components/core/list/listRouteState';
import { createItemsListTourSteps, stopItemsListTour } from './items-list-tour';

// sotto i 3 caratteri il backend ignora la ricerca
const SEARCH_MIN = 3;
const LIST_SIZE = [15, 25, 50, 100];

export default {
	name: 'Items',
	// pagina, righe, ordinamento, ricerca e filtri stanno nell'URL: refresh e ritorno dalle schede ripartono da li'
	mixins: [
		listRouteState({
			filters: { categories: 'array', brand: 'array', suppliers: 'array', color: 'array', images: 'boolean' },
			perPageOptions: LIST_SIZE,
		}),
	],
	/*
	 * Il controller del tutorial nasce qui e non in `data()`: quello che sta in
	 * `data()` viene reso reattivo in profondita da Vue 2, e in quel passaggio i
	 * `ref` del motore verrebbero srotolati nel loro valore grezzo.
	 */
	setup() {
		return {
			tour: useTour(createItemsListTourSteps(), { onStop: stopItemsListTour }),
		};
	},
	data() {
		return {
			menu: false,
			dialogconfirmUpdate: false,
			componentKey: 0,
			right: true,
			permanent: false,
			miniVariant: false,
			expandOnHover: false,
			background: false,
			clippedOrder: 0,
			linkdownload: '',
			paramsUrls: '',
			items: [],
			listcategories: [],
			setinterval: '',
			snackbar: {
				snackbar: false,
				color: '',
				mode: '',
				timeout: 6000,
				text: '',
			},
			// ricerca: default, sovrascritti da quello che c'e' nell'URL
			settings: this.listSettingsFromRoute({
				search: '',
				filters: {
					categories: [],
					brand: [],
					variants: [],
					suppliers: [],
					// etichette colore (la select "Tags"): prima mancava qui e il filtro non era reattivo
					color: [],
					images: '',
				},
				options: {
					sortBy: ['created_at'],
					sortDesc: [true],
					page: 1,
					itemsPerPage: 15,
				},
			}),
			listSize: LIST_SIZE,
			searchfield: '',
			search: '',
			selected: [],
			total: 0,
			totalwarehouse: 0,
			headers: [
				// colonna del menu a tre puntini: non si ordina (ordinava per un campo vuoto e la lista restava in caricamento)
				{ text: '', value: '', sortable: false },
				{ text: 'Status', value: 'is_active', sortable: false },
				{ text: 'Creazione', value: 'created_at', sortable: true },
				{ text: 'Aggiornamento', value: 'updated_at', sortable: true },
				{ text: 'Immagine', value: 'trans.name', sortable: false },
				{ text: 'Prodotto', value: 'trans.name' },
				{ text: 'Variante', value: 'variants.qt' },
				{ text: 'Prezzo', value: 'variants.sell' },
				{ text: 'Marketplace', value: 'markeplace', sortable: false },
				{ text: 'Lingue', value: 'lingue', sortable: false },
				{ text: '', value: '', sortable: false },
			],
			disabled: false,
			absolute: false,
			openOnHover: false,
			value: false,
			closeOnClick: true,
			closeOnContentClick: true,
			offsetX: false,
			offsetY: true,
			dialogconfirm: false,
			dialogconfirmImport: false,
			isActive: true,
			show1: false,
			messages: {
				email: [],
				name: [],
				password: [],
			},
			options: [
				{ text: '', value: '' },
				{ text: 'si', value: true },
				{ text: 'no', value: false },
			],
			listCategories: [],
			treeCategories: [],
			selectVariants: [],
			arrayTree: [],
			Totale: '',
			Fee: '',
			Refund: '',
			Gain: '',
			page: 1,
			isMobile: false,
			operation: '',
			magento: false,
			shopify: false,
			fattureincloud: false,
			langDefault: '',
			brands: [],
			suppliers: [],
			selectionType: 'leaf',
			findParant: [],
			open: [1, 2],
			selectColor: ['red', 'pink', 'purple', 'indigo', 'blue', 'green', 'yellow', 'orange', 'grey'],
			listValueVariantConvert: [],
			menuInline: [
				{
					operation: 'edit',
					text: 'Modifica',
				},

				{
					operation: 'print',
					text: 'Stampa etichetta',
				},
				{
					operation: 'duplicate',
					text: 'Duplica',
				},
				{
					operation: 'delete',
					text: 'Elimina',
				},
				{
					operation: 'join',
					text: 'Unisci',
				},
				{
					operation: 'buy',
					text: 'Acquisti',
				},
				{
					operation: 'sell',
					text: 'Vendite',
				},
				{
					operation: 'stats',
					text: 'Statistiche',
				},
			],
		};
	},
	/*created () {
            this.setDialog(false)
            this.initialize();

        },*/
	filters: {
		fixed: function (value) {
			if (!value) return '';
			return value.toFixed(2);
		},
	},
	async created() {
		this.setDialog(false);
		this.setExistFilter(true);
		this.listLoad();

		this.linkdownload = `${this.getUrl}nocors/items/download`;
		//await this.fetchSetting();
		let promises = [];
		promises.push(this.fetchSetting());
		//promises.push(this.fetchService(['ebay', 'magento', 'shopify', 'fattureInCloud']));
		promises.push(this.fetchServiceactive(['fattureInCloud', 'ebay', 'magento', 'shopify', 'mws']));
		const result = await Promise.all(promises);

		const status = result[1];

		this.langDefault = _.find(this.getSettings.languages, { default: true }).lang;
		const category = new Category(this.getSettings.categories, this.langDefault);
		await category.buildTotal();
		await category.refactorCategory();
		await category.createPath();
		await category.dynamicSort();

		this.listcategories = await category.getTree;
		this.selectVariants;

		this.getSettings.variants.forEach(el => {
			const name = el.trans.find(vname => vname.lang === this.langDefault);

			const values = [];
			if (name) {
				el.values.forEach(elvalue => {
					const nameValue = elvalue.trans.find(vvalue => vvalue.lang === this.langDefault);

					if (nameValue && elvalue._id && nameValue.name) {
						values.push({ _id: elvalue._id, name: nameValue.name });
						this.listValueVariantConvert.push({ _id: elvalue._id, name: name.name, value: nameValue.name });
					}
				});
				this.selectVariants.push({ name: name.name, values: values });
			}
		});

		/*const magento = status.find(el => {
			return el.service === 'magento';
		});
		if (magento?.service) {
			this.magento = magento.active;
		}*/

		let shopify = status.find(el => el.service === 'shopify' && el.active === true);

		if (shopify) {
			this.shopify = shopify.active;
		}

		const fattureincloud = status.find(el => {
			return el.service === 'fattureInCloud';
		});
		if (fattureincloud?.service) {
			this.fattureincloud = fattureincloud.active;
		}

		this.fetchSelect({}).then(result => {
			this.brands = result.data;
		});

		this.fetchSupplierSelect({}).then(result => {
			this.suppliers = result.data;
		});
		//await this.getDataFromApi();
	},
	watch: {
		fab: {
			top(val) {
				this.fab.bottom = !val;
			},
			right(val) {
				this.fab.left = !val;
			},
			bottom(val) {
				this.fab.top = !val;
			},
			left(val) {
				this.fab.right = !val;
			},
		},
	},
	components: {
		TourOverlay,
		FormMap,
		FormFile,
		ImportShopify,
		KeyValueCard,
		LingueFlags,

		//VuetifyDraggableTreeview
	},
	computed: {
		// sotto i 769px le righe diventano card
		mobileCards() {
			return this.$vuetify.breakpoint.width < 769;
		},
		imagePlaceholder() {
			return require(`@/assets/images/picture.svg`);
		},
		// stessi colori del menu etichetta della tabella desktop
		coloriEtichetta() {
			return ['red', 'pink', 'purple', 'indigo', 'blue', 'green', 'yellow', 'orange', 'grey'];
		},
		...mapGetters({
			getAutenticate: 'profile/getAutenticate',
			getToken: 'profile/getToken',
			getUrl: 'settings/getUrl',

			getDialog: 'settings/getDialog',
			getPreload: 'settings/getPreload',
			getSnackbar: 'snackbars/getSnackbar',
			getColor: 'snackbars/getColor',
			getMultiline: 'snackbars/getMultiline',
			getTimeout: 'snackbars/getTimeout',
			getVertical: 'snackbars/getVertical',
			getText: 'snackbars/getText',
			getIndex: 'items/getIndex',
			getItems: 'items/getItems',
			getLanguage: 'profile/getLanguage',
			getDrawerFilter: 'settings/getDrawerFilter',
			getSortBy: 'items/getSortBy',
			getSortDesc: 'items/getSortDesc',
			getCategoriesTree: 'categories/getCategoriesTree',
			getCategoriesChildrean: 'categories/getCategoriesChildrean',
			getSettings: 'settings/getSetting',
			getServices: 'services/getServices',
		}),

		navStateFilter: {
			get: function () {
				return this.getDrawerFilter;
			},
			set: function () {
				return this.getDrawerFilter;
			},
		},
		navStateOrder: {
			get: function () {
				return this.clippedOrder;
			},
			set: function () {
				return this.clippedOrder;
			},
		},
	},
	methods: {
		marketplaceAttivi(item) {
			return (item.marketplace || []).filter(market => market.status === 'Confirmed');
		},
		// stessi dati delle colonne Prodotto/Variante/Prezzo/date della tabella desktop
		campiCard(item) {
			const v = item.variants || {};
			const valuta = v.currency || '';
			const prezzo = value => (this.formatPrice(value) ? `${this.formatPrice(value)} ${valuta}`.trim() : '');
			const variante = item.variante
				? (v.variants || [])
					.map(el => `${(el && el.name && el.name.trans) || ''} ${(el && el.value && el.value.trans) || ''}`.trim())
					.filter(Boolean)
					.join(', ')
				: '';
			const data = value => (value ? this.$moment(value).format('DD/MM/YYYY') : '');
			const conIva = prezzo(v.pricevat);
			const campi = [
				{ label: 'SKU', value: v.sku },
				{ label: 'EAN', value: v.ean },
				{ label: 'Modello', value: item.model },
				{ label: 'Fornitore', value: this.supplierNames(item) },
				{ label: 'Variante', value: variante },
				{ label: 'Qtà', value: v.qt !== undefined && v.qt !== null ? `${v.qt}${v.unit && v.unit.trans ? ' ' + v.unit.trans : ''}` : '' },
				{ label: 'Vendita', value: prezzo(v.sell), strong: true },
				{ label: 'Con IVA', value: conIva ? `${conIva}${item.vat ? ' (' + item.vat + '%)' : ''}` : '' },
				{ label: 'Acquisto', value: prezzo(v.buy) ? `${prezzo(v.buy)} cad.` : '' },
				{ label: 'Unità per vendita', value: v.qtunit },
				{ label: 'Peso', value: item.weight ? `${item.weight} gr.` : '' },
				{ label: 'Creazione', value: data(item.created_at) },
				{ label: 'Aggiornamento', value: data(item.updated_at) },
			];
			// nella card restano solo le voci valorizzate: il prodotto ha molti campi facoltativi
			return campi.filter(campo => campo.value !== undefined && campo.value !== null && campo.value !== '');
		},
		...mapMutations({
			setLogout: 'profile/setLogout',
			setDialog: 'settings/setDialog',

			setPreload: 'settings/setPreload',
			setSnackbar: 'snackbars/setSnackbar',
			setClearError: 'settings/setClearError',
			setMessages: 'settings/setMessages',
			setItems: 'items/setItems',
			setItem: 'items/setItem',
			setIndex: 'items/setIndex',
			setExistFilter: 'settings/setExistFilter',
			setDrawerFilter: 'settings/setDrawerFilter',
		}),
		...mapActions({
			fetchItems: 'items/asyncFetchData',
			fetchTotal: 'items/asyncFetchTotalData',
			deleteItems: 'items/deleteItems',

			destroyData: 'items/destroyData',
			saveData: 'users/saveData',
			fetchSetting: 'settings/asyncFetchData',
			fetchLists: 'brands/fetchLists',
			fetchSelect: 'brands/fetchSelect',
			fetchSupplierSelect: 'suppliers/fetchSelect',
			getItemShopify: 'items/getItemShopify',
			getNewItemShopify: 'items/getNewItemShopify',
			setUpdateStatusItem: 'items/setUpdateStatusItem',
			setUpdateStatusItemVariant: 'items/setUpdateStatusItemVariant',
			updateSingleItemShopify: 'items/updateSingleItemShopify',
			fetchService: 'services/getServiceFetch',
			fetchServiceactive: 'services/getServiceFetchActive',

			//'resetMessages' : 'settings/resetMessages'
		}),
		exportItems(format) {
			return this.exportAsync('items', format, {
				search: this.searchfield,
				categories: this.settings.filters.categories,
				brands: this.settings.filters.brand,
				suppliers: this.settings.filters.suppliers,
				selected: this.selected,
			});
		},
		async getItemsShopifyAz() {
			this.dialogconfirmImport = false;
			this.setPreload(true);
			await this.getItemShopify();
			this.setPreload(false);
			this.getDataFromApi();
			this.snackbar.color = 'success';
			this.snackbar.text = 'I prodotti saranno caricati in pochi secondi';
			this.snackbar.snackbar = true;
			this.snackbar.mode = 'multi-line';
			this.snackbar.timeout = 5000;
		},
		navigateTo(operation, item) {
			switch (operation) {
				case 'edit':
					this.editItem(item);
					break;
				case 'map':
					this.editMap(item);
					break;
				case 'duplicate':
					this.duplicateItem(item);
					break;
				case 'delete':
					this.deleteItem(item);
					break;
				case 'join':
					this.joinItem(item);
					break;
				case 'print':
					this.printItem(item);
					break;
				case 'buy':
					this.buyItem(item);
					break;
				case 'sell':
					this.sellItem(item);
					break;
				case 'stats':
					this.statsItem(item);
					break;
			}
		},
		formatPrice(value) {
			if (value === null || value === undefined || value === '' || isNaN(value)) return '';
			return Number(value).toFixed(3);
		},
		supplierNames(item) {
			// Il supplier arriva come array dal lookup, ma su dati vecchi puo' essere un oggetto singolo
			const suppliers = Array.isArray(item.supplier) ? item.supplier : [item.supplier];

			return suppliers
				.map(supplier => supplier?.Company?.trim())
				.filter(Boolean)
				.join(', ');
		},
		convertSearch(match) {
			let result = match;

			if (this.settings?.search && result) {
				let re = new RegExp(this.settings.search, 'gi');
				result = match.replace(re, `<mark>${this.settings.search}</mark>`);
			}
			return result;
		},
		getImageMarketplace(img) {
			let logo = '';

			switch (img) {
				case 'Amazon':
					logo = require(`@/assets/images/Amazon.svg`);
					break;
				case 'Ebay':
					logo = require(`@/assets/images/Ebay.svg`);
					break;
				case 'Magento':
					logo = require(`@/assets/images/Magento.svg`);
					break;
				case 'Shopify':
					logo = require(`@/assets/images/framework/shopify.svg`);
					break;
				case 'Store':
					logo = require(`@/assets/images/store.svg`);
					break;
				default:
					logo = require(`@/assets/images/flag/map.svg`);
			}
			return logo;
		},
		getImageFlag(img) {
			try {
				return require(`@/assets/images/flag/${img}.svg`);
			} catch (e) {
				return require(`@/assets/images/flag/map.svg`);
			}
		},
		imageUrlAlt(index) {
			this.$refs[index][0].src = require(`@/assets/images/picture.svg`);
		},

		clearSearchInput() {
			this.search = '';
		},

		getImage(item) {
			let image = false;

			if (item.images.length > 0) {
				const firstImage = item.images[0];

				if (firstImage.sizes.length > 0) {
					image = firstImage.sizes[0]?.value || false;
				}
			}

			for (let el of item.images) {
				for (let variant of el.variants) {
					const match = item.variants.variants.find(tip => tip.value?._id?.toString() === variant?.toString());

					if (match) {
						return el?.sizes?.[0]?.value || false;
					}
				}
			}

			return image ? image : false;
		},

		createImage(item) {
			let image = '';

			if (item.images.length > 0) {
				let first = item.images[0];

				if (first.sizes.length > 0) {
					let firstimage = first.sizes[0];
					image = firstimage.value;
				}
			}

			for (let el of item.images) {
				for (let ol of el.variants) {
					const check = item.variants.variants.find(tip => tip.value?._id?.toString() === ol?.toString());
					//console.log('check', check);
					if (check) {
						return el?.sizes?.[0]?.value;
					}
				}
			}

			try {
				return image;
			} catch (e) {
				return require(`@/assets/images/picture.svg`);
			}
			//return image;
			//require(`@/assets/images/picture.svg`)
		},
		toggleDrawerFilter() {
			this.setDrawerFilter(!this.getDrawerFilter);
			this.clippedOrder = 0;
			//this.$store.commit('setDrawer') = !this.$store.state.drawer;
		},

		download() {
			return (
				'nocors/items/download?token=' +
				this.getToken +
				'&search=' +
				this.searchfield +
				'&categories=' +
				this.settings.filters.categories +
				'&brands=' +
				this.settings.filters.brands +
				'&selected=' +
				this.selected
			);
		},
		onResize() {
			this.isMobile = window.innerWidth < 769;
		},
		filterName(data) {
			return _.find(data, { lang: this.getLanguage }).text;
			//return text
		},
		changeFlag(item, color) {
			let url = 'items/update-flag';
			let payload = item;
			this.preload = true;
			this.editIndex = this.getItems.indexOf(item);
			axios
				.post(`${this.getUrl}${url}`, { item: payload, color: color }, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(() => {
					this.preload = false;
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con  successo';
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
					Object.assign(this.getItems[this.editIndex], { Color: color });
				})
				.catch(err => {
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}
						this.snackbar.color = 'error';
						this.snackbar.text = err.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.preload = false;
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},

		changeStatus(item) {
			try {
				this.setPreload(true);

				this.setUpdateStatusItem({
					_id: item._id,
					id: item.id,
					is_active: item.is_active,
				}).then(() => {
					//this.total = result.total
					//this.items = result.data.data
					this.setPreload(false);
					this.getDataFromApi().then(() => {
						this.snackbar.color = 'success';
						this.snackbar.text = 'Update successfully';
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.selected = [];
						this.setPreload(false);
					});
					/*if (result.data.data.ok) {
                            this.snackbar.color = "success";
                            this.snackbar.text = "Update successfully";
                            this.snackbar.snackbar = true;
                            this.snackbar.mode = 'multi-line';
                            this.snackbar.timeout = 5000;
                        }*/
				});

				//console.log(response);
			} catch (err) {
				console.log(err);
			}

			//console.log(item)
		},
		changeStatusVariant(item) {
			try {
				this.setPreload(true);

				this.setUpdateStatusItemVariant({
					_id: item._id,
					id: item.id,
					variants: item.variants._id,
					active: item.variants.active,
				})
					.then(result => {
						//this.total = result.total
						//this.items = result.data.data
						if (result.data.data.ok) {
							this.snackbar.color = 'success';
							this.snackbar.text = 'Update successfully';
							this.snackbar.snackbar = true;
							this.snackbar.mode = 'multi-line';
							this.snackbar.timeout = 5000;
						}
					})
					.finally(el => {
						this.setPreload(false);
					});

				//console.log(response);
			} catch (err) {
				console.log(err);
			}

			//console.log(item)
		},

		async getCategoryMagento() {
			this.setPreload(true);
			await this.getFetchCategoryMagento();
			this.setPreload(false);
			this.getDataFromApi();
			this.snackbar.color = 'success';
			this.snackbar.text = 'Le categorie verranno caricate in pochi secondi';
			this.snackbar.snackbar = true;
			this.snackbar.mode = 'multi-line';
			this.snackbar.timeout = 5000;
		},
		/*async getItemsShopifyAz() {
			this.dialogconfirmImport = false;
			this.setPreload(true);
			await this.getItemShopify();
			this.setPreload(false);
			this.getDataFromApi();
			this.snackbar.color = 'success';
			this.snackbar.text = 'I prodotti saranno caricati in pochi secondi';
			this.snackbar.snackbar = true;
			this.snackbar.mode = 'multi-line';
			this.snackbar.timeout = 5000;
		},*/
		// crea, modifica e duplica sono pagine: la lista resta nel suo URL e ci si torna uguale.
		// Si aprono solo dalla riga (tre puntini); l'_id della riga e' quello del prodotto.
		duplicateItem(item) {
			this.setClearError({});
			this.setMessages();
			this.$router.push(`/items/${item._id}/duplicate`);
		},
		editItem(item) {
			this.setClearError({});
			this.setMessages();
			this.$router.push(`/items/${item._id}`);
		},
		async editMap(key) {
			this.componentKey += 1;
			let item;

			if (!key) {
				let el = this.selected[0];
				item = _.find(this.getItems, i => {
					return i._id === el;
				});
			} else {
				item = key;
			}

			this.setClearError({});
			this.operation = 'FormMap';

			this.setIndex(this.getItems.indexOf(item));
			this.setItem(item);
			this.setMessages();
			this.setDialog(true);
			this.setSnackbar(false);
		},
		async printItem(key) {
			let item;

			if (!key) {
				let el = this.selected[0];
				item = _.find(this.getItems, i => {
					return i._id === el;
				});
			} else {
				item = key;
			}

			let variant_input = item.variants.variants.map(item => ({
				name: item.name._id,
				nameCmplete: {
					created_at: item.name.created_at,
					_id: item.name._id,
					trans: [{ _id: '63d0f0c0735985ed97e14937', lang: 'it', name: item.name.trans }],
					is_active: item.name.is_active,
					filter: item.name.filter,
				},
				value: item.value._id,
				valueComplete: {
					_id: item.value._id,
					trans: [{ _id: '63d0f0c0735985ed97e1493c', lang: 'it', name: item.value.trans }],
				},
				_id: item._id,
			}));

			if (item) {
				let url = `${this.getUrl}nocors/items/sku/print?token=${this.getToken}&sku=${item.variants.sku}&ean=${item.variants.ean}&variant=${JSON.stringify(variant_input)}&name=${
					item.trans?.name
				}&brand=${item.brand?._id}`;
				window.open(encodeURI(url), '_blank');
			}
		},
		// Unisci / Acquisti / Vendite / Statistiche sono pagine della variante (/items/:id/<tool>?sku=):
		// la riga resta nello store cosi' la pagina non deve ricaricarla
		openVariantTool(tool, key) {
			const item = key || _.find(this.getItems, i => i._id === this.selected[0]);
			if (!item || !item._id || !item.variants) return;
			this.setItem(item);
			this.$router.push({ path: `/items/${item._id}/${tool}`, query: { sku: item.variants.sku } });
		},
		joinItem(key) {
			this.openVariantTool('join', key);
		},
		buyItem(key) {
			this.openVariantTool('purchases', key);
		},
		sellItem(key) {
			this.openVariantTool('sales', key);
		},
		statsItem(key) {
			this.openVariantTool('stats', key);
		},
		createItem() {
			this.setClearError({});
			this.setMessages();
			this.$router.push('/items/new');
		},
		async importItemFromShopify() {
			this.componentKey += 1;
			this.setClearError({});
			this.operation = 'ImportShopify';
			this.setMessages();
			this.setDialog(true);
			this.setSnackbar(false);
		},
		async getFileCategories() {
			this.componentKey += 1;
			this.setClearError({});
			//await this.resetMessages();
			//console.log(this.getOrders.indexOf(item));
			//console.log(item)
			this.operation = 'FormFile';

			this.setMessages();
			this.setDialog(true);
			this.setSnackbar(false);
		},

		propSetMessages(text) {
			this.snackbar.color = 'success';
			this.snackbar.text = text;
			this.snackbar.text = text;
			this.snackbar.snackbar = true;
			this.snackbar.mode = 'multi-line';
			this.snackbar.timeout = 5000;
			this.operation = '';
		},
		// il mixin della lista riporta a pagina 1 e ricarica quando cambia la ricerca
		getSearch() {
			this.settings.search = _.size(this.searchfield) >= SEARCH_MIN ? this.searchfield : '';
		},

		async getDataFromApi() {
			try {
				this.setPreload(true);
				this.isActive = true;
				//const {sortBy, sortDesc, page, itemsPerPage} = this.settings.options
				//console.log("Inizio this.fetchItems")

				let result = await this.fetchItems(this.settings);
				// errore dal server: lo store non restituisce la paginazione
				if (!result) {
					return;
				}

				this.total = result.total;
				this.totalwarehouse = await this.fetchTotal(this.settings);
				//this.items = result.data.data
				this.selected = [];
				this.$forceUpdate();

				//console.log(response);
			} catch (err) {
				console.log(err);
			} finally {
				// anche in caso di errore la pagina non deve restare in caricamento
				this.setPreload(false);
			}
		},
		async openNew() {
			this.setClearError({});
			//await this.resetMessages();
			this.setMessages();
			this.setDialog(true);
			this.setSnackbar(false);
		},

		/*checkpresenza(item) {
                return this.selected.includes(item)
            },
*/
		closeSnackbar() {
			this.setSnackbar(false);
		},
		async confirm() {
			/*let payload = this.form;
                try {
                    this.setPreload(true);
                    this.preload = true;
                    let response = await this.fetchUsers(payload);

                    this.getDataFromApi().then(res => {

                        this.snackbar.color = "success";
                        this.snackbar.text = this.$vuetify.lang.t(`$vuetify.messages.${data.data}`);
                        this.snackbar.snackbar = true;
                        this.snackbar.mode = 'multi-line';
                        this.snackbar.timeout = 5000;
                        this.setPreload(false);
                    })

                } catch (err) {
                    console.log(err);
                }
                this.preload = false;*/
		},
		importItemConfirmShopify() {
			this.dialogconfirmImport = true;
		},
		async importNewItemShopify() {
			this.setPreload(true);

			await this.getNewItemShopify();
			this.setPreload(false);
			this.getDataFromApi();
			this.snackbar.color = 'success';
			this.snackbar.text = 'Nuovi prodotti inseriti';
			this.snackbar.snackbar = true;
			this.snackbar.mode = 'multi-line';
			this.snackbar.timeout = 5000;
		},
		confirmUpdateFromShopify() {
			this.dialogconfirmUpdate = true;
		},
		updateFromShopify(key) {
			this.messages = [];
			this.dialogconfirmUpdate = false;
			let item;

			if (!key) {
				let el = this.selected[0];
				item = _.find(this.getItems, i => {
					return i._id === el;
				});
			} else {
				item = key;
			}
			this.setPreload(true);

			this.updateSingleItemShopify(item)
				.then(() => {
					this.setPreload(false);
					this.getDataFromApi().then(() => {
						this.snackbar.color = 'success';
						this.snackbar.text = 'Operazione effettuata con successo';
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.selected = [];
					});
				})
				.catch(error => {
					console.log(error);
				});
		},
		deleteItem(item) {
			this.dialogconfirm = true;
			this.form = item;
		},

		confirmDelete() {
			this.dialogconfirm = false;

			this.messages = [];
			let paypload = [];
			if (_.size(this.selected) > 0) {
				_.forEach(this.selected, cat => {
					let index = _.find(this.getItems, { _id: cat });

					if (index) {
						paypload.push(index);
					}
				});
			}
			if (this.form) {
				paypload.push(this.form);
			}
			this.deleteItems(paypload)
				.then(() => {
					this.setPreload(false);
					this.getDataFromApi().then(() => {
						this.snackbar.color = 'success';
						this.snackbar.text = 'Operazione effettuata con successo';
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.selected = [];
					});
				})
				.catch(error => {
					console.log(error);
				});
			//this.deleteCategories()
		},
	},
	beforeDestroy() {
		// Se si lascia la pagina a giro aperto, vanno staccati i listener del tutorial.
		this.tour.stop();
		this.destroyData();

		//console.log('Main Vue destroyed')
	},
};
</script>

<style scoped>
/* spazi fra le colonne dimezzati (16 -> 8 px per lato): la lista ha 11 colonne e senza questo andava in
   scroll orizzontale su schermi piu' stretti; la prima (tre puntini) resta senza margini */
.tabella-compatta ::v-deep th:not(:first-child),
.tabella-compatta ::v-deep td:not(:first-child) {
	padding-left: 8px !important;
	padding-right: 8px !important;
}
.product-cell {
	min-width: 220px;
	max-width: 320px;
	padding-top: 6px !important;
	padding-bottom: 6px !important;
	line-height: 1.35;
}
.stack-cell {
	padding-top: 6px !important;
	padding-bottom: 6px !important;
	line-height: 1.35;
}
.price-purchase {
	margin-top: 4px;
	padding-top: 4px;
	border-top: 1px dashed rgba(0, 0, 0, 0.15);
}
.product-name {
	font-weight: 600;
}
.product-label {
	font-size: 0.7rem;
	color: rgba(0, 0, 0, 0.5);
	text-transform: uppercase;
}
/* vista card: niente layout a colonne, ogni riga e' un blocco e la card prende il 100% */
.table-cards ::v-deep table {
	display: block;
	width: 100%;
}
.item-cards,
.item-cards tr {
	display: block;
	width: 100%;
}
.item-cards tr,
.item-cards tr:hover {
	background: transparent !important;
}
.item-cards td {
	display: block;
	width: 100%;
	border-bottom: none !important;
	height: auto !important;
}
/* respiro tra le card e il bordo della card che contiene la tabella */
.item-cards tr:first-child td {
	padding-top: 12px !important;
}
.item-cards tr:last-child td {
	padding-bottom: 12px !important;
}
.item-cards tr + tr td {
	padding-top: 8px !important;
}
.item-label {
	font-size: 14px;
	color: rgba(0, 0, 0, 0.6);
}
.item-brand {
	font-size: 13px;
	font-weight: 600;
	color: rgba(0, 0, 0, 0.7);
}
</style>
